import React, { useEffect, useRef } from 'react';
import styles from '../style/HeaderLogo.module.scss';

import logo from '../../../assets/image/DHI_Logo_White.png';

import { useHistory } from 'react-router';

export default function HeaderLogo({
  onClick,
}: {
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}) {
  const history = useHistory();

  const [showDropdwon, setShowDropdown] = React.useState(false);

  const refOne = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
  }, []);

  const handleClickOutside = (event: any) => {
    if (refOne.current && !refOne.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  return (
    <div
      onClick={onClick}
      role="logo"
      aria-label="site logo"
      className={styles.logo}
    >
      <img
        onClick={() => {
          history.push('/');
        }}
        style={{ cursor: 'pointer' }}
        src={logo}
        alt={'dhi logo'}
      />
      <div
        ref={refOne}
        className={`${styles.logoTextContainer} ${
          showDropdwon ? styles.active : ''
        }`}
        onClick={() => setShowDropdown(!showDropdwon)}
      >
        <h1>Metocean Data Portal</h1>
      </div>
    </div>
  );
}
